import { render, staticRenderFns } from "./AnotherInPoint.vue?vue&type=template&id=4095d9a5&scoped=true&"
import script from "./AnotherInPoint.vue?vue&type=script&lang=js&"
export * from "./AnotherInPoint.vue?vue&type=script&lang=js&"
import style0 from "./AnotherInPoint.vue?vue&type=style&index=0&id=4095d9a5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4095d9a5",
  null
  
)

export default component.exports